import React from "react";
import { Route, Switch } from "react-router-dom";
import Main from "./main/index";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/home`} component={Main} />
    </Switch>
  );
};

export default Production;
